import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@material-ui/core';

import LoadingIndicator from '../LoadingIndicator';

import { useSetIframeHeight } from '../../hooks';

import { STATICPAGES } from "../../main_config";
import { useParams } from "react-router";

const Iframe = ({ url, file, title = 'Iframe Ecco' }) => {
  const [iframeHeight, iframeRef, handleResizeHeight] = useSetIframeHeight();
  const src = url ? url : `${STATICPAGES}/${file}.html?v=1000`;
  const { prod } = useParams();
  window.addEventListener('resize',handleResizeHeight);
  return (
    <Box>
      { !iframeHeight && <LoadingIndicator /> }
      <iframe
        ref={iframeRef}
        id="moduleIframe"
        title={title===undefined ? file : title}
        src={prod ? `${src}#${prod}` : src}
        frameBorder="0"
        allowFullScreen
        onLoad={handleResizeHeight}
        width="100%"
        height={`${iframeHeight}px`}
        scrolling="no"
      /> 
    </Box> 
  )
}

Iframe.propTypes = {
  url: PropTypes.string,
  file: PropTypes.string,
  title: PropTypes.string
}

export default Iframe;
